<template>
  <div id="person">
    <div id="content">
      <Header
        :page="'participant'"
        :title_one="'participant'"
        :action_one="'edit'"
        :person_id="player.id"
        :banner_docsok_msg="doc_ok"
      ></Header>

      <div class="left">
        <div class="title">{{ $t("titles.form_person_info") }}</div>
        <div class="row">
          <!-- NAME -->
          <div class="item mid">
            <div class="label">{{ $t("params.name") }}</div>
            <div class="value">{{ player.name }}</div>
          </div>

          <!-- SURNAME -->
          <div class="item mid">
            <div class="label">{{ $t("params.surname") }}</div>
            <div class="value">{{ player.surname }}</div>
          </div>

          <!-- DNI -->
          <div class="item mid">
            <div class="label">
              {{ $t("params." + player.document_type_text) }}
            </div>
            <div class="value">{{ player.dni }}</div>
          </div>

          <!-- BIRTHDAY -->
          <div class="item mid">
            <div class="label">{{ $t("params.birthday") }}</div>
            <div class="value">{{ player.birthday }}</div>
          </div>

          <!-- GENDER -->
          <div class="item mid">
            <div class="label">{{ $t("params.gender") }}</div>
            <div class="value">
              {{
                player.gender
                  ? player.gender == "1"
                    ? $t("gender.male")
                    : $t("gender.female")
                  : "-"
              }}
            </div>
          </div>

          <!-- COUNTRY -->
          <div class="item mid">
            <div class="label">{{ $t("params.country") }}</div>
            <div
              class="value"
              v-if="
                typeof countries !== 'undefined' &&
                typeof countries[player.country] !== 'undefined'
              "
            >
              {{ countries[player.country].name }}
            </div>
          </div>

          <!-- ADDRESS -->
          <div class="item mid" v-if="!is_virtual">
            <div class="label">{{ $t("params.address") }}</div>
            <div class="value">{{ player.address ? player.address : "-" }}</div>
          </div>

          <!-- CP -->
          <div class="item mid" v-if="!is_virtual">
            <div class="label">{{ $t("params.cp") }}</div>
            <div class="value">{{ player.cp ? player.cp : "-" }}</div>
          </div>

          <!-- CITY -->
          <div class="item mid" v-if="!is_virtual">
            <div class="label">{{ $t("params.city") }}</div>
            <div class="value">{{ player.city ? player.city : "-" }}</div>
          </div>

          <!-- STATE -->
          <div class="item mid">
            <div class="label">{{ $t("params.state") }}</div>
            <div class="value">{{ player.state ? player.state : "-" }}</div>
          </div>

          <!-- PHONE1 -->
          <div class="item mid">
            <div class="label">{{ $t("params.phone") }}</div>
            <div class="value">
              {{ player.phone != "" ? player.phone : "-" }}
            </div>
          </div>

          <!-- PHONE2 -->
          <div class="item mid">
            <div class="label">{{ $t("params.phone2") }}</div>
            <div class="value">
              {{ player.mobile != "" ? player.mobile : "-" }}
            </div>
          </div>

          <!-- EMAIL -->
          <div class="item mid" v-if="!is_virtual">
            <div class="label">{{ $t("params.email") }}</div>
            <div class="value">
              {{ player.email != "" ? player.email : "-" }}
            </div>
          </div>

          <!-- MEDICATION -->
          <div class="item mid" v-if="!is_virtual">
            <div class="label">{{ $t("params.medicamento") }}</div>
            <div class="value">
              {{ player.medicamento ? player.medicamento : $t("no") }}
            </div>
          </div>

          <!-- FOOD ALLERGY -->
          <div class="item mid" v-if="!is_virtual">
            <div class="label">{{ $t("params.alergy") }}</div>
            <div
              class="value"
              v-if="typeof player.alergy != 'undefined' && player.alergy != ''"
            >
              <span
                class="alergy"
                v-for="alergy in player.alergy"
                v-bind:key="alergy.id"
              >
                <template v-if="alergies[alergy]">
                  {{ $t("alergy." + alergies[alergy].name) }}
                </template>
              </span>
            </div>
            <div class="value" v-else>{{ $t("no") }}</div>
          </div>

          <!-- OTHER ALLERGIES -->
          <div class="item mid" v-if="!is_virtual">
            <div class="label">{{ $t("params.other_allergies") }}</div>
            <div class="value">
              {{ player.other_allergies ? player.other_allergies : "-" }}
            </div>
          </div>

          <!-- ESPECIAL DIET -->
          <div
            class="item mid"
            v-if="user.event_name != 'NikeCamp BCN' && !is_virtual"
          >
            <div class="label">{{ $t("params.diet") }}</div>
            <div
              class="value"
              v-if="
                typeof diets !== 'undefined' &&
                typeof diets[player.diet] !== 'undefined'
              "
            >
              {{ $t(diets[player.diet].name) }}
            </div>
            <div class="value" v-else>{{ $t("no") }}</div>
          </div>

          <!-- SWIM -->
          <div class="item mid" v-if="!is_virtual">
            <div class="label">{{ $t("swim") }}</div>
            <div class="value">{{ player.swim ? $t("si") : $t("no") }}</div>
          </div>

          <!-- (NIKE) Height -->
          <div class="item mid" v-if="player.altura != null && !is_virtual">
            <div class="label">{{ $t("params.altura") }}</div>
            <div class="value">{{ player.altura }}</div>
          </div>

          <!-- (PGA) JOIN TO PGA -->
          <!-- <div class="item mid" v-if="player.join_campus != null">
                  <div class="label">{{$t('params.join_campus')}}</div>
                  <div class="value" v-if="joinCampus && joinCampus[player.join_campus]">{{$t( 'campus.' + joinCampus[player.join_campus].name )}}</div>
                </div> -->

          <!-- (PGA) Clothing size -->
          <div class="item mid" v-if="player.shirt_size != null && !is_virtual">
            <div class="label">{{ $t("campus.size") }}</div>
            <div
              class="value"
              v-if="shirt_sizes && shirt_sizes[player.shirt_size]"
            >
              {{ $t("campus." + shirt_sizes[player.shirt_size].name) }}
            </div>
          </div>

          <!-- (PGA) Club Name -->
          <div class="item mid" v-if="player.club_name != null && !is_virtual">
            <div class="label">{{ $t("params.club_name") }}</div>
            <div class="value">
              {{ player.club_name ? player.club_name : "-" }}
            </div>
          </div>

          <!-- (NIKE) GoalKeeper -->
          <div
            class="item mid"
            v-if="
              player.goalkeeper != null &&
              user.event_name != 'NikeCamp BCN' &&
              !is_virtual
            "
          >
            <div class="label">{{ $t("campus.goalkeeper") }}</div>
            <div class="value">
              {{ player.goalkeeper == "1" ? $t("si") : $t("no") }}
            </div>
          </div>

          <!-- HOW MEET -->
          <!-- <div class="item mid">
                  <div class="label">{{$t('params.how_meet_present')}}</div>
                  <div class="value" v-if="how_meet && how_meet[player.how_meet]">{{$t(how_meet[player.how_meet].name)}}</div>
                </div> -->

          <!-- LANG -->
          <div class="item mid">
            <div class="label">{{ $t("params.language_communications") }}</div>
            <div class="value" v-if="languages && languages[player.language]">
              {{ languages[player.language].name }}
            </div>
          </div>

          <!-- LOTTERY -->
          <div
            class="item mid"
            v-if="user.event_name != 'NikeCamp BCN' && !is_virtual"
          >
            <div class="label">{{ $t("params.lottery") }}</div>
            <div class="value">
              {{ player.lottery == "1" ? $t("si") : $t("no") }}
            </div>
          </div>
        </div>
      </div>

      <div class="right">
        <template v-if="!is_virtual">
          <div class="title">{{ $t("titles.responsable") }}</div>
          <div v-if="Object.keys(player.responsable1).length" class="row">
            <!-- NAME -->
            <div class="item">
              <div class="label">{{ $t("params.name") }}</div>
              <div class="value">{{ player.responsable1.name }}</div>
            </div>

            <!-- SURNAME -->
            <div class="item">
              <div class="label">{{ $t("params.surname") }}</div>
              <div class="value">{{ player.responsable1.surname }}</div>
            </div>

            <!-- PHONE -->
            <div class="item">
              <div class="label">{{ $t("params.phone") }}</div>
              <div class="value">{{ player.responsable1.phone }}</div>
            </div>

            <!-- DNI -->
            <div class="item" v-if="player.responsable1">
              <div class="label">
                {{ $t("params." + player.responsable1.document_type_text) }}
              </div>
              <div class="value">{{ player.responsable1.dni }}</div>
            </div>
          </div>
        </template>

        <div class="title">{{ $t("titles.campus_info") }}</div>
        <div class="row">
          <!-- CAMPUS -->
          <div class="item" id="campus">
            <div class="label">{{ $t("params.campus_programme") }}</div>
            <div class="value">
              <span
                class="campus"
                v-for="campus in player.campus"
                :key="campus.id"
              >
                {{ $t(campus.type) }}: ( {{ campus.start_date }} -
                {{ campus.end_date }} )
              </span>
            </div>
          </div>

          <!-- MODALITY -->
          <div class="item" v-if="event.type_id == 4">
            <div class="label">{{ $t("campus.modality") }}</div>
            <div class="value">
              {{
                player.modality
                  ? player.modality == "1"
                    ? $t("campus.intern")
                    : $t("campus.extern")
                  : "-"
              }}
            </div>
          </div>

          <!-- BUS -->
          <div class="item" v-if="event.type_id == 4">
            <div class="label">{{ $t("campus.bus") }}</div>
            <div class="value">
              {{ player.bus == "0" ? $t("no") : $t(busOptions(player.bus)) }}
            </div>
          </div>

          <!-- PICKUP -->
          <div
            class="item"
            v-if="
              event.type_id == 4 &&
              player.bus &&
              [1, 3].includes(parseInt(player.bus))
            "
          >
            <div class="label">{{ $t("titles.external") }}</div>
            <div class="value">
              {{ $t(pickupOptions(player.pickup)) }}
            </div>
          </div>

          <!-- RETURNIT -->
          <div
            class="item"
            v-if="
              event.type_id == 4 &&
              player.bus &&
              [2, 3].includes(parseInt(player.bus))
            "
          >
            <div class="label">{{ $t("titles.returnit") }}</div>
            <div class="value">
              {{ $t(pickupOptions(player.returnit)) }}
            </div>
          </div>

          <!-- (PGA) JOIN TO PGA -->
          <div class="item" v-if="player.join_campus != null">
            <div class="label">{{ $t("params.join_campus") }}</div>
            <div
              class="value"
              v-if="joinCampus && joinCampus[player.join_campus]"
            >
              {{ $t("campus." + joinCampus[player.join_campus].name) }}
            </div>
          </div>
        </div>
      </div>

      <Header
        :page="'participant'"
        :title_one="'campus_info_documents'"
        :action_two="'edit'"
        :person_id="player.id"
        :show_banners="false"
      ></Header>

      <div class="left">
        <div class="title">
          {{ $t("titles.medicaments_allergies_and_intolerances") }}
        </div>
        <div class="row">
          <!-- ANTITERMIC -->
          <div class="item mid" v-if="event.type_id == 4">
            <div class="label">{{ $t("params.auth_antitermic") }}</div>
            <div class="value">
              {{ player.antitermic == "1" ? $t("bool.si") : $t("bool.no") }}
            </div>
          </div>
          <!-- ALLERGIES -->
          <div class="item mid">
            <div class="label">{{ $t("params.allergies_intolerances") }}</div>
            <div class="value">{{ player.allergies_intolerances }}</div>
          </div>
          <!-- REACTIONS ALLERGIES -->
          <div class="item mid">
            <div class="label">{{ $t("params.allergic_reactions") }}</div>
            <div class="value">{{ player.allergic_reactions }}</div>
          </div>
          <!-- WHAT TO DO ALLERGIES -->
          <div class="item mid">
            <div class="label">{{ $t("params.what_to_do_allergy") }}</div>
            <div class="value">{{ player.what_to_do_allergy }}</div>
          </div>
          <!-- MEDICINES -->
          <div class="item mid">
            <div class="label">{{ $t("params.medicamento") }}</div>
            <div class="value">{{ player.medicines }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">{{ $t("titles.external") }}</div>
        <div class="row">
          <!-- ANTITERMIC -->
          <div class="item mid">
            <div class="label">{{ $t("params.participant_goes_alone") }}</div>
            <div class="value">
              {{ player.alone_home == "1" ? $t("bool.si") : $t("bool.no") }}
            </div>
          </div>
          <!-- ANTITERMIC -->
          <div class="item mid" v-if="player.alone_home != '1'">
            <div class="label">{{ $t("params.people_authorize") }}</div>
            <div class="value">{{ player.externals }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Header from "@/components/layout/Header";

export default {
  name: "CampusHome",
  components: {
    i18n,
    Header,
  },
  data() {
    return {
      player: {
        id: "",
        name: "",
        surname: "",
        address: "",
        city: "",
        country: "",
        cp: "",
        state: "",
        nacionality: "",
        phone: "",
        phone2: "",
        mobile: "",
        email: "",
        dni: "",
        document_type: "",
        b_alergy: "",
        alergy: "",
        other_allergies: "",
        diet: "",
        birthday: "",
        gender: "",
        campus: "",
        modality: "",
        lottery: "",
        bus: "",
        club_name: "",
        shirt_size: "",
        join_campus: "",
        goalkeeper: "",
        b_medicamento: "",
        medicamento: "",
        swim: "",
        altura: "",
        language: "",
        b_news: "",
        how_meet: "",
        responsable1: {},
        document_type_text: "",
        antitermic: "",
        allergies_intolerances: "",
        allergic_reactions: "",
        what_to_do_allergy: "",
        medicines: "",
        alone_home: "",
        externals: "",
      },
      alergies: {},
      countries: {},
      campus_types: {},
      diets: {},
      how_meet: {},
      languages: {},
      shirt_sizes: {},
      joinCampus: {},
      is_virtual: false,
      doc_ok: true
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },

    event() {
      return this.$store.getters.getCurrentEvent();
    },
  },
  created() {
    // save campus
    this.$store.commit("setCampus", true);

    // get player information
    var self = this;

    this.$store
      .dispatch("person/loadPersonCampus", {
        campus_id: this.user.event_id,
        participant_id: this.user.participant_id,
      })
      .then(function () {
        // save player information
        let person = self.$store.getters["person/getPerson"];
        if (
          (!person.antithermal && [4, 5].includes(self.event.type_id)) ||
          !person.medicines ||
          !person.externals ||
          !person.image_right
        ) {
          self.doc_ok = false
        }
        // save information
        self.player.id = person.id;
        self.player.name = person.name;
        self.player.surname = person.surname;
        self.player.address = person.address;
        self.player.city = person.city;
        self.player.country = person.country_id;
        self.player.cp = person.cp;
        self.player.state = person.state;
        self.player.nacionality = person.nacionality;
        self.player.phone = person.phone;
        self.player.phone2 = person.phone2;
        self.player.mobile = person.mobile;
        self.player.email = person.email;
        self.player.dni = person.dni;
        self.player.document_type = person.document_type;
        self.player.b_alergy = person.b_alergy;
        self.player.alergy = person.alergy;
        self.player.other_allergies = person.other_allergies;
        self.player.diet = person.diet;
        self.player.birthday = moment(person.birthday).format("DD/MM/YYYY");
        self.player.gender = person.gender;
        self.player.campus = person.campus;
        self.player.modality = person.modality;
        self.player.lottery = person.lottery;
        self.player.bus = person.bus;
        self.player.pickup = person.pickup;
        self.player.returnit = person.returnit;
        self.player.club_name = person.club_name;
        self.player.shirt_size = person.shirt_size;
        self.player.join_campus = person.join_campus;
        self.player.goalkeeper = person.goalkeeper;
        self.player.b_medicamento = person.b_medicamento;
        self.player.medicamento = person.medicamento;
        self.player.swim = person.swim;
        self.player.altura = person.altura;
        self.player.b_medicamento = person.b_medicamento;
        self.player.medicamento = person.medicamento;

        self.player.antitermic = person.antitermic;
        self.player.alone_home = person.alone_home;
        if (person.allergies) {
          var allergies = JSON.parse(person.allergies);
          self.player.what_to_do_allergy = allergies.wd ? allergies.wd : "";
          if (allergies.a) {
            self.player.allergies_intolerances = "";
            allergies.a.forEach((allergy) => {
              if (self.player.allergies_intolerances != "") {
                self.player.allergies_intolerances += ", ";
              }
              self.player.allergies_intolerances += allergy;
            });
          }
          if (allergies.r) {
            self.player.allergic_reactions = "";
            allergies.r.forEach((allergy) => {
              if (self.player.allergic_reactions != "") {
                self.player.allergic_reactions += ", ";
              }
              self.player.allergic_reactions += allergy;
            });
          }
        }
        if (person.externals) {
          var aExternals = JSON.parse(person.externals);
          self.player.externals = "";
          aExternals.forEach((external) => {
            if (self.player.externals != "") {
              self.player.externals += ", ";
            }
            self.player.externals +=
              external.name + " " + external.surname + " - " + external.dni;
          });
        }
        if (person.medicaments) {
          var aMedicines = JSON.parse(person.medicaments);
          console.log(aMedicines);
          self.player.medicines = "";
          aMedicines.forEach((medicine) => {
            if (self.player.medicines != "") {
              self.player.medicines += ", ";
            }
            self.player.medicines += medicine.name;
          });
        }

        (self.player.language = person.lang),
          (self.player.b_news = person.b_news),
          (self.player.how_meet = person.how_meet);

        switch (self.player.document_type) {
          case "1":
            self.player.document_type_text = "dni";
            break;
          case "2":
            self.player.document_type_text = "nie";
            break;
          case "3":
            self.player.document_type_text = "passport";
            break;
        }

        if (person.responsable_1 != null) {
          self.player.responsable1.name = person.responsable_1.name;
          self.player.responsable1.surname = person.responsable_1.surname;
          self.player.responsable1.dni = person.responsable_1.dni;
          self.player.responsable1.document_type =
            person.responsable_1.document_type;
          self.player.responsable1.phone = person.responsable_1.phone;

          switch (self.player.responsable1.document_type) {
            case "1":
              self.player.responsable1.document_type_text = "dni";
              break;
            case "2":
              self.player.responsable1.document_type_text = "nie";
              break;
            case "3":
              self.player.responsable1.document_type_text = "passport";
              break;
          }
        }

        // get countries and alergies
        self.$store
          .dispatch("getCampusInfo", { event_id: self.user.event_id })
          .then(function () {
            self.countries = self.$store.getters["getCountries"];
            self.alergies = self.$store.getters["getAlergy"];
            self.campus_types = JSON.parse(
              JSON.stringify(self.$store.getters["getCampusType"])
            );
            self.diets = self.$store.getters["getDiets"];
            self.how_meet = self.$store.getters["getHowMeet"];
            self.languages = self.$store.getters["getLanguages"];
            self.shirt_sizes = self.$store.getters["getShirtSizes"];
            self.joinCampus = self.$store.getters["getJoinCampus"];

            // looop for each campus
            for (let i in self.player.campus) {
              // get campus
              let campus = self.campus_types[self.player.campus[i]];
              console.log("created -> campus", campus);

              if (self.user.event_name == "MICCAMP BCN") {
                var sCampusName = campus.type.split(".");
                campus.type =
                  sCampusName[0] +
                  "." +
                  sCampusName[1] +
                  "." +
                  sCampusName[2] +
                  "_" +
                  sCampusName[3];
              }

              // format start and end date
              campus.start_date = moment(
                campus.start_date,
                "YYYY-MM-DD"
              ).format("DD/MM/YYYY");
              campus.end_date = moment(campus.end_date, "YYYY-MM-DD").format(
                "DD/MM/YYYY"
              );

              // save campus information
              self.player.campus[i] = campus;
              if (campus.type == "campus.pga_virtual") self.is_virtual = true;
            }
          });
      });
  },
  methods: {
    redirect() {
      this.$router
        .push({
          name: "campus_player_edit",
          params: { person_id: this.player.id },
        })
        .catch((err) => {});
    },

    busOptions(bus) {
      switch (parseInt(bus)) {
        case 1:
          return "campus.bus_type.go";
        case 2:
          return "campus.bus_type.back";
        case 3:
          return "campus.bus_type.both";
      }

      return "bool.no";
    },

    pickupOptions(pickup) {
      switch (parseInt(pickup)) {
        case 1:
          return "campus.pickup.bcncenter";
        case 2:
          return "campus.pickup.bcnsants";
        case 3:
          return "campus.pickup.bcnairport";
      }

      return "bool.no";
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile {
  display: none;
}

#content {
  padding: 0 12px !important;

  .row {
    background-color: #f5f5f5;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    // min-height: 100px;

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 100%;
      vertical-align: top;
      &.mid {
        width: 50%;
        float: left;
        display: inline-block;
      }

      .alergy,
      .campus {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;

        &:after {
          content: ", ";
        }
        &:last-of-type:after {
          content: "";
        }
      }

      .campus {
        display: block;
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }
    .label {
      width: 100px;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
      display: inline;
    }

    #campus {
      .label,
      .value {
        display: inline-block;
      }
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: $main-color-t30;
    display: block;
    width: 100%;
    margin: 6px;

    &.sub {
      margin-left: 12px;
    }
  }

  .person {
    background: none;
    width: 100%;
    overflow: hidden;
    text-align: left;

    .person-role,
    .person-name {
      @include text-ellipsis();
      display: block;
      font-size: 24px;
      color: $main-color;
      width: 100%;
      padding: 2px;
    }

    .person-role {
      margin-right: 6px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      line-height: 16px;
    }
  }

  .left,
  .right {
    display: inline-block;
    padding: 12px;
  }
  .left {
    width: 60%;
  }
  .right {
    width: 40%;
  }
}

@include media("<=desktop") {
  #content {
    padding: 12px !important;

    .left,
    .right {
      width: 100%;
      display: block;
      padding: 0;
    }

    .row {
      .item {
        &.mid {
          width: 100%;
        }
      }
    }
  }
}

@include media(">phone", "<tablet") {
  #content {
  }
}
</style>
